import { Link } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import TipSection from '../components/TipSection';

const OurTips = () => {
  return (
    <div className="OurTips">
      <Header />
      <div className="mt-32 sm:mt-36 lg:mt-32">
        {/* Hero Section */}
        <div
        className="relative bg-cover bg-center"
        style={{
          backgroundImage: "url('/assets/images/tc-heart-hands.jpeg')",
          height: 'calc(66vh - 90px)',
          minHeight: '400px',
        }}
      >
        <div className="absolute inset-0 flex items-end justify-center pb-0">
          <div className="w-full bg-white bg-opacity-90 py-8 px-8">
            <div className="max-w-6xl mx-auto text-center">
              <h1 className="text-4xl md:text-5xl font-light mb-0" style={{ color: '#000' }}>
                Our Tips
              </h1>
            </div>
          </div>
        </div>
      </div>

      {/* Application Tips */}
      <TipSection title="Application Tips" isAlt={true}>
        <p className="mb-6">
          <strong>Check it's the right role for you</strong> – take a look at{' '}
          <Link to="/our-values" className="underline" style={{ color: '#2f4c74' }}>our values</Link> and{' '}
          <Link to="/hear-from-our-people" className="underline" style={{ color: '#2f4c74' }}>hear from our people</Link>{' '}
          about what it's like working at Testa Care to make sure you feel this is the right role for you.
        </p>
        <p className="mb-6">
          <strong>Make sure you provide your full employment history</strong> – we need your full employment history from when you leave education, either on our application or you can upload your latest cv. You'll need to include all job titles and employments gaps. Where you'd had various jobs and there are gaps, you'll need to set out what you were doing – e.g. studying, Travelling, Looking after family, or working abroad.
        </p>
        <p className="mb-6">
          <strong>We'll need your references</strong> – we need a minimum of two references, one of which should be from your most recent employer. If you've worked with children or vulnerable adults previously, we'll need references from all of those employers to satisfy safer recruitment principles.
        </p>
        <p className="mb-6">
          <strong>Before you submit</strong> – check all the fields and make sure if uploading a cv it is the latest version.
        </p>
        <p className="mb-0">
          <strong>Check your inbox</strong> – once you've submitted, you'll receive an email from us acknowledging your application has been received. If you can't see this, then check your junk/spam as it may have gone in there.
        </p>
      </TipSection>

      {/* Your Interview: what you need to know */}
      <TipSection title="Your Interview: what you need to know" isAlt={false}>
        <p className="mb-0">
          We typically have a two-stage interview process; the first stage is a telephone conversation with one of our recruiters. The second is an in-person interview which would typically be with a registered manager.
        </p>
      </TipSection>

      {/* Interview Tips */}
      <TipSection title="Interview Tips" isAlt={true}>
        <p className="mb-6">
          <strong>Call us if you need us</strong> - If you're lost getting to the interview, don't be afraid to give the office a ring and we can either direct you or put you in touch with someone to make navigating your way there as easy as possible.
        </p>
        <p className="mb-6">
          <strong>Research Testa Care</strong> - Our Managers love when a candidate has read a little about what we do or has seen the activities our young people experience. So go and have a look on our website or social media accounts as this will give you a sense of what it is like to work for us.
        </p>
        <p className="mb-6">
          <strong>Prepare some examples</strong> – We will ask questions around{' '}
          <Link to="/our-values" className="underline" style={{ color: '#2f4c74' }}>our values</Link>{' '}
          so have a think about some examples you can share of where you've worked in a team, developed positive relationships and delivered on your promises. We will want to explore more around your experience, not necessarily all in a work context, as well as what you've learned from these experiences to help us to know more about you and how you might react to similar situations that you may come across in the role.
        </p>
        <p className="mb-6">
          <strong>Ask Questions</strong> - The interview is a two-way process and it's important that we are the right place for you, so please feel free to come with lots of questions for the hiring manager about what it's like to work in their home or school so you can be confident of pursuing your career here with us.
        </p>
        <p className="mb-6">
          <strong>Don't forget your documents</strong> - Given the sector in which we work and to ensure the safeguarding of children in our care, I'm sure you'll understand that employment is subject to a disclosure and barring service (DBS) check. The exact documents you need to bring will be detail in your interview invite email. If you've lived abroad within the last ten years, you might also be asked to complete an overseas criminal record check. Not all criminal convictions would prevent employment. We'd also love to see any certificates of any relevant qualifications.
        </p>
        <p className="mb-8">
          <strong>Breathe</strong> - You're at your best when you're comfortable and we'll do all we can to make you feel welcome and at ease. Just don't forget to breathe and please be yourself as that's who we'll hopefully be hiring!
        </p>
        <div className="flex justify-center">
          <img
            src="/assets/images/tc-safety-kit.jpeg"
            alt="Lightbulb"
            className="w-64 h-64 object-contain"
          />
        </div>
      </TipSection>

        <Footer />
      </div>
    </div>
  );
};

export default OurTips;




